import { LESSON_START_UPDATE, LESSON_START_VALUE_CHANGED } from './actions';
import { combineReducers } from 'redux';

function formData(state = { initiator: '1', 'new': '', reason: '' }, action) {
    switch (action.type) {
        case LESSON_START_VALUE_CHANGED:
            return { ...state, [action.payload.name]: action.payload.value };
        case `${LESSON_START_UPDATE}_FULFILLED`:
            return { ...state, reason: '' };
        default:
            return state;
    }
}

function errors(state = {}, action) {
    switch (action.type) {
        case `${LESSON_START_UPDATE}_PENDING`:
            return {};
        case `${LESSON_START_UPDATE}_REJECTED`:
            const payload = action.payload || {};
            let errorData = {};

            if (payload.data && typeof payload.data === 'object') {
                errorData = payload.data;
            } else if (payload.response && payload.response.data) {
                errorData = payload.response.data;
            } else if (typeof payload === 'object' && payload !== null && !payload.status) {
                errorData = payload;
            }

            const fieldErrors = {};
            if (typeof errorData === 'object' && errorData !== null) {
                Object.keys(errorData).forEach(key => {
                    if (key !== '__onClick' && key !== 'non_field_errors') {
                        const error = errorData[key];
                        if (error) {
                            fieldErrors[key] = Array.isArray(error) ? error[0] : error;
                        }
                    }
                });
            }

            return fieldErrors;
        default:
            return state;
    }
}

function nonFieldError(state = null, action) {
    switch (action.type) {
        case `${LESSON_START_UPDATE}_PENDING`:
            return null;
        case `${LESSON_START_UPDATE}_REJECTED`:
            const payload = action.payload || {};
            let errorData = {};

            if (payload.data && typeof payload.data === 'object') {
                errorData = payload.data;
            } else if (payload.response && payload.response.data) {
                errorData = payload.response.data;
            } else if (typeof payload === 'object' && payload !== null && !payload.status) {
                errorData = payload;
            }

            if (errorData.non_field_errors) {
                const nonField = errorData.non_field_errors;
                return Array.isArray(nonField) ? nonField[0] : nonField;
            }
            // Show API message when we have field errors (e.g. "Ошибка валидации данных")
            if (payload.message && typeof payload.message === 'string') {
                return payload.message;
            }
            if (payload.getMessage && typeof payload.getMessage === 'function') {
                return payload.getMessage();
            }

            return null;
        default:
            return state;
    }
}

export default combineReducers({
    formData,
    errors,
    nonFieldError,
});



// WEBPACK FOOTER //
// ./src/incab/common/LessonStartForm/reducers.js